<script setup lang="ts">
import { KsRadioGroupRoot } from '@aschehoug/kloss-2'
</script>

<template>
  <KsRadioGroupRoot class="radio-group-root">
    <slot />
  </KsRadioGroupRoot>
</template>

<style lang="scss" scoped>
  .radio-group-root {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
</style>
